var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('page-header',{attrs:{"title":"Formulário de inscrição"}}),(_vm.loading)?_c('card-loading-transparent'):_vm._e(),(!_vm.loading)?_c('div',[_c('show-form',{attrs:{"course":_vm.course}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }